document.addEventListener("DOMContentLoaded", initialiseDiscountField);
document.addEventListener("refreshPromoField", initialiseDiscountField);

document.addEventListener('on:line-item:change', () => {
  initialiseDiscountField(true); // true = user interaction
});

document.addEventListener('on:cart:add', () => {
  initialiseDiscountField(true); // true = user interaction
});

function initialiseDiscountField(userInteraction = false, button = null) {
  console.log("INIT DISCOUNT FIELD");

  const clearBtn = document.querySelector("#clear-discount-btn");
  const applyBtn = document.querySelector("#apply-discount-btn");
  const discountCodeError = document.querySelector("#discount-code-error");
  const discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
  const discountCodeSuccessMessage = document.querySelector(".discount-code-success");
  const discountCodeErrorContainer = document.querySelector('.discount-code-error-container');
  const discountCodeSavings = document.querySelector('.discount-code-savings');
  const discountCodeIndicator = document.querySelector(".discount-code-indicator");
  const discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
  const discountCodeInput = document.querySelector("#discount-code-input");
  const automaticDiscountCode = document.querySelector('#auto-discount-code');

  if (!discountCodeWrapper) return;
  discountCodeWrapper.style.display = "block";

  // --- Fetch cart discounts and update UI ---
  fetch('/cart?view=discount')
    .then(res => res.text())
    .then(data => {
      const cartData = JSON.parse(data);
      if (cartData.discounts && cartData.discounts.length > 0) {
        const appliedPromo = cartData.discounts[0];

        if(discountCodeValue) discountCodeValue.innerHTML = `${appliedPromo.title} (${appliedPromo.amount} ${Shopify.currency.active})`;
        if(discountCodeIndicator) discountCodeIndicator.innerHTML = appliedPromo.title;
        if(discountCodeSavings) discountCodeSavings.innerHTML = appliedPromo.amount; 
        if(discountCodeErrorContainer) discountCodeErrorContainer.style.display = 'none';
        if(discountCodeSuccessMessage) discountCodeSuccessMessage.style.display = userInteraction ? 'block' : 'none';

        const totalCartSelector = document.querySelector('.cart-subtotal__amount span');
        const comparePriceCartSelector = document.querySelector('.cart-subtotal__amount s');
        if(totalCartSelector) totalCartSelector.innerHTML = cartData.total_price_with_currency;
        if(comparePriceCartSelector) comparePriceCartSelector.innerHTML = cartData.total_full_price;
      } else {
        // No discount applied
        if(discountCodeValue) discountCodeValue.innerHTML = "";
        if(discountCodeIndicator) discountCodeIndicator.innerHTML = "";
        if(discountCodeSavings) discountCodeSavings.innerHTML = "";
        if(discountCodeSuccessMessage) discountCodeSuccessMessage.style.display = 'none';
        if(discountCodeErrorContainer) discountCodeErrorContainer.style.display = 'none';
      }
    });

  // --- Apply automatic discount if available ---
  if (automaticDiscountCode && automaticDiscountCode.getAttribute('data-title')) {
    applyDiscount(automaticDiscountCode.getAttribute('data-title'));
  }

  // Clear discount button
  if(clearBtn){
    clearBtn.onclick = (e) => {
      e.preventDefault();
      clearDiscount();
    }
  }

  function clearDiscount() {
    fetch("/checkout?discount=%20");
    if(discountCodeValue) discountCodeValue.innerHTML = "";
    if(discountCodeIndicator) discountCodeIndicator.innerHTML = "";
    if(discountCodeSavings) discountCodeSavings.innerHTML = "";
    if(discountCodeSuccessMessage) discountCodeSuccessMessage.style.display = 'none';
    if(discountCodeErrorContainer) discountCodeErrorContainer.style.display = 'none';
  }

  function applyDiscount(code) {
    if(!code) return;

    if(applyBtn){
      applyBtn.innerHTML = "Appliquer <div class='loader'></div>";
      applyBtn.style.pointerEvents = "none";
    }

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
    .then(res => res.json())
    .then(cart => {
      fetch('/cart?view=discount')
        .then(res => res.text())
        .then(data => {
          const cartData = JSON.parse(data);
          const appliedPromo = cartData.discounts.find(d => d.title.toUpperCase() === code.toUpperCase());

          if(appliedPromo) {
            if(discountCodeWrapper) discountCodeWrapper.style.display = "block";
            if(discountCodeValue) discountCodeValue.innerHTML = `${appliedPromo.title} (${appliedPromo.amount} ${Shopify.currency.active})`;
            if(discountCodeIndicator) discountCodeIndicator.innerHTML = appliedPromo.title;
            if(discountCodeSavings) discountCodeSavings.innerHTML = appliedPromo.amount;
            if(discountCodeErrorContainer) discountCodeErrorContainer.style.display = 'none';
            if(discountCodeSuccessMessage) discountCodeSuccessMessage.style.display = 'block';

            const totalCartSelector = document.querySelector('.cart-subtotal__amount span');
            const comparePriceCartSelector = document.querySelector('.cart-subtotal__amount s');
            if(totalCartSelector) totalCartSelector.innerHTML = cartData.total_price_with_currency;
            if(comparePriceCartSelector) comparePriceCartSelector.innerHTML = cartData.total_full_price;
          } else {
            // Invalid code
            if(discountCodeError) discountCodeError.innerText = `Le code promo ${code} n'a pas pu être appliqué`;
            if(discountCodeErrorContainer) discountCodeErrorContainer.style.display = 'block';
          }
        });
    })
    .finally(() => {
      if(applyBtn){
        applyBtn.innerHTML = "Appliquer";
        applyBtn.style.pointerEvents = "all";
      }
    });
  }

  // Manual apply button click
  if(userInteraction && button?.id === "apply-discount-btn") {
    const inputValue = button.closest('.discount-code-input-container').querySelector('#discount-code-input').value;
    applyDiscount(inputValue);
  }
}

// Automatic discount observer
function initialiseObserver() {
  const targetNode = document.getElementById("auto-discount-code");
  if(!targetNode) return;

  const config = { attributes: true };
  const callback = (mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes" && mutation.attributeName === "data-title") {
        let code = targetNode.getAttribute('data-title');
        if(code) initialiseDiscountField(false, null);
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

document.addEventListener("DOMContentLoaded", initialiseObserver);
